const view = "site-section-tree";

export const siteSectionTree = {
  view,
  backButton: `${view}/back-button`,
  addSectionButton: `${view}/add-section-button`,
  manageCategoriesButton: `${view}/manage-categories-button`,
  siteStructure: `${view}/site-structure`,
  skeleton: `${view}/skeleton`,
  header: {
    selectButton: `${view}/filters/select-button`,
    searchTextInput: `${view}/filters/search-text-input`,
    visibleSectionsCounter: `${view}/filters/visible-sections-counter`,
  },
  bulkCategory: {
    selectionBar: `${view}/bulk-category/selection-bar`,
    closeButton: `${view}/bulk-category/close-button`,
    selectedCount: `${view}/bulk-category/selected-count`,
    categorySelect: `${view}/bulk-category/category-select`,
    categoryHelp: `${view}/bulk-category/category-help`,
    assignButton: `${view}/bulk-category/assign-button`,
    removeButton: `${view}/bulk-category/remove-button`,
    selectAllCheckbox: `${view}/bulk-category/select-all-checkbox`,
    sectionCheckbox: (sectionId: string | number): string => `${view}/bulk-category/section/${sectionId}/checkbox`,
  },
  siteCard: {
    card: `${view}/site-card`,
    siteName: `${view}/site-card/site-name`,
    siteCardAddButton: `${view}/site-card/actions/add-button`,
    siteCardCategoryButton: `${view}/site-card/actions/category-button`,
  },
  sectionCard: {
    card: `${view}/section-card`,
    sectionName: `${view}/section-card/section-name`,
    sectionChildrenCount: `${view}/section-card/section-children-count`,
    sectionCategory: `${view}/section-card/section-category`,
    sectionCardAddButton: `${view}/section-card/actions/add-button`,
    sectionCardCategoryButton: `${view}/section-card/actions/category-button`,
    sectionCardEditButton: `${view}/section-card/actions/edit-button`,
  },
};
